import CTA from "../components/home/CTA";
import Hero from "../components/home/Hero";
import Process from "../components/home/Process";
import ServicesPreview from "../components/home/ServicesPreview";
import StatsHome from "../components/home/StatsHome";
import TrustSection from "../components/home/TrustSection";
import ServiciosTopografia from "../components/home/ServiciosTopografia";
import PlanosDestacados from "../components/home/PlanosDestacados";
import LogoMarquee from "../components/home/LogoMarquee";
//import PlansPreview from "../components/home/PlansPreview";
import ScrollToTopBTN from "../components/ui/ScrollToTopBTN";
import PromoModal from "../components/ui/PromoModal";
import SEO from "../components/SEO";

const Home = () => {
  return (
    <>
        <SEO
        title="Planix | Planos Arquitectónicos e Ingeniería Civil"
        description="Descubre planos arquitectónicos modernos, diseños de casas, topografía y servicios de ingeniería civil con Planix."
        image="https://www.planixapp.com/cover.jpg"
        type="website"
      />

      <div>

        <PromoModal />
        <Hero />
        <TrustSection />
        <ServicesPreview />
        <StatsHome />
        <PlanosDestacados />
        <Process />
        <ServiciosTopografia />
        <LogoMarquee />
        {/*<PlansPreview />*/}
        <CTA />

        <ScrollToTopBTN />
        
      </div>
    </>

  );
};

export default Home;